export default __webpack_public_path__ + "static/media/M1 - Goat Herd.d5083bb1.png";